import { Injector } from "@angular/core";
import { ListView } from "../../../Data/ListView";
import { Art57Node } from "../Art57Node";
import { Art57NodeList } from "../Art57NodeList";
import { TreeNodePreviousEVCode } from "../Entity/TreeNodePreviousEVCode";
import { ErrorType } from "../../ErrorType";
import { environment } from "../../../../../../environments/environment";

export class TreeNodePreviousEVCodeList extends Art57NodeList {
    constructor(injector: Injector, parent: Art57Node) {
      super(injector, new ListView(), 'Previous EV Codes ({param})');
      this.parent = parent;
      this.labelNodeName = 'Previous EV Codes';      
    }
  
    override refreshLabel(): void {
      this.label = this.labelTemplate.replace(
        '{param}',
        this.getLabelParamFromChildren()
      );
    }
  
    override validateBusinessRules(): any[] {
      let errors: any = [];
      if (this.parent
         && (!this.children || this.children.length == 0)
         && this.parent.data.model.authorisation 
         && this.parent.data.model.authorisation.authorisationstatus 
         && (this.parent.data.model.authorisation.authorisationstatus.value == 8 
          || this.parent.data.model.authorisation.authorisationstatus.value == 9)) {
        errors.push({
          node: this,
          errorID: this.key,
          errorType: ErrorType.bussinessValidationError,
          controlId: undefined,
          controlLabel: '',
          error: 'Section is Mandatory',
        });
      } else {
        errors.push({
          node: this,
          errorID: this.key,
          errorType: ErrorType.errorInactive,
          controlId: undefined,
          controlLabel: '',
          error: '',
        });
      }
    
      return errors;
    }
  
    override createChildTemplate(params: any): Art57Node[] | null {
      let node = new TreeNodePreviousEVCode(this.ioc!, this);
      node.data.model.type = params.nodeType;
      this.children?.push(node);
  
      this.refreshLabel();
      return [node];
    }
  
    override getMessage(): any {
      let previousevcodes: Art57Node[] = [];
      this.children?.forEach((node) => {
        let previousevcode = node as Art57Node;
        previousevcodes.push(previousevcode.getMessage());
      });
      if (previousevcodes.length > 0) {
        return { previousevcodes: { previousevcode: previousevcodes } };
      } else {
        return undefined;
      }
    }
  
    override getHeaders(): string[] {
      return ['Type', 'Previous EV Code'];
    }
  
    override cloneNode(newParent: Art57Node): Art57Node|undefined {
      let clonedNode: TreeNodePreviousEVCodeList = new TreeNodePreviousEVCodeList(
        this.ioc!,
        newParent
      );
  
      this.children?.forEach((child) => {
        let childToClone = child as Art57Node;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
  
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

  
      return clonedNode;
    }
  }

